enum EStableCryptoCurrency {
    USDTERC = 'USDTERC', // USDT but n.exchange naming
    USDT = 'USDT',
    USDC = 'USDC',
    BUSD = 'BUSD',
    DAI = 'DAI',
    UST = 'UST',
    TUSD = 'TUSD',
    PAX = 'PAX',
}

enum EUnstableCryptoCurrency {
    NEO = 'NEO',
    XLM = 'XLM',
    XRP = 'XRP',
    BMH = 'BMH',
    DASH = 'DASH',
    COB = 'COB',
    COSS = 'COSS',
    BIX = 'BIX',
    HT = 'HT',
    KNC = 'KNC',
    BNB = 'BNB',
    KCS = 'KCS',
    XMR = 'XMR',
    ZEC = 'ZEC',
    NANO = 'NANO',
    QTM = 'QTM',
    EOS = 'EOS',
    OMG = 'OMG',
    GNT = 'GNT',
    BDG = 'BDG',
    BCH = 'BCH',
    XVG = 'XVG',
    DOGE = 'DOGE',
    RNS = 'RNS',
    ETH = 'ETH',
    LTC = 'LTC',
    BTC = 'BTC',
}

const CryptoCurrencyMap = {
    ...EStableCryptoCurrency,
    ...EUnstableCryptoCurrency,
}

type TCryptoCurrency = typeof CryptoCurrencyMap

export type { TCryptoCurrency }
export { CryptoCurrencyMap, EStableCryptoCurrency, EUnstableCryptoCurrency }
